import React from 'react';
import { Plus } from './plus';
import { More } from './more';
import { Lock } from './lock';

export default ({
    nodeObj,
    node,
    left,
    top,
    rl,
    // prId,
    ntm,
    hasMoreAdd,
    cursorBecomesMove,
    cursorBecomesPointer,
    showToolTipFor,
    hideToolTip,
    addnodetabImage,
    lockTabImg,
    nearTabImg,
    addnodetabYellowImage,
    addnodetabGreenImage,
    addnodetabRedImage,
    moretabImage,
    onclickedAddNodeTab,
    stopStageClickPropagation,
    userTouchedNode,
    hideMatchBubble,
    reloadFocusAndGotoHighlight,
    callHookForMessageAlert,
    translatedLabels,
    buildRefObj,
    callRefObj,
  }) => {

  const props = {
    nodeObj,
    node,
    left,
    top,
    rl,
    // prId,
    ntm,
    hasMoreAdd,
    cursorBecomesMove,
    cursorBecomesPointer,
    showToolTipFor,
    hideToolTip,
    addnodetabImage,
    lockTabImg,
    nearTabImg,
    onclickedAddNodeTab,
    addnodetabYellowImage,
    addnodetabGreenImage,
    addnodetabRedImage,
    moretabImage,
    stopStageClickPropagation,
    userTouchedNode,
    hideMatchBubble,
    reloadFocusAndGotoHighlight,
    callHookForMessageAlert,
    translatedLabels,
    buildRefObj,
    callRefObj,
  };


  if(typeof(rl) !== 'undefined' ){
    return [
      <Lock
        key={Math.random()}
        {...props}/>,
    ]

  } else if(typeof(hasMoreAdd) !== 'undefined'  && hasMoreAdd){


    /*

        [Yellow tab with refresh icon within.]  User clicks tab to redraw tree to avoid adding profile that could already exist in tree.
        Hook:  callNotifyProfileAdd('13038')

     */

    return [
      <More
        key={Math.random()}
        {...props}/>,
    ]
  } else {

    /*

        [Red plus symbol.] User has to resolve nearby tree matches before adding to existing profile.

     */

    return [
      <Plus
        key={Math.random()}
        {...props}/>,
    ]
    // return [
    //   <More
    //     key={Math.random()}
    //     {...props}/>,
    // ]

  }
};

